import Lang, { IStrings, selectByPrefix } from "../../../common/utils/LanguageManager";

import pl from "./lang/pl";
import en from "./lang/en";
import de from "./lang/de";
import es from "./lang/es";

const strings: IStrings = {
	pl: pl,
	en: en,
	de: de,
	es: es,
}

export default {
	maxDateMessage: () => Lang("maxDateMessage", strings),
	minDateMessage: () => Lang("minDateMessage", strings),

	getDefaultByPrefix: function <T>(obj: T, prefix: keyof T, key?: string) {
		var defaultValue = selectByPrefix(obj, prefix);
		if (defaultValue)
			return defaultValue;
		if (!key)
			return null;
		return Lang(key, strings);
	},
	get: (name: string) => Lang(name, null),
}